import CustomFilterSelect from "./CustomFilterSelect";
const FilterVerificationStatus = (props: any) => {
  return (
    <CustomFilterSelect
      before={props?.before != null && props.before !== "" ? props.before : ""}
      source="referralVerify"
      label="Verification Status"
      choices={[
        { id: "Verified", name: "Verified" },
        { id: "Rejected", name: "Rejected" },
        { id: "Not Verified", name: "Not Verified" },
        { id: "Pending", name: "Pending" },
        // { id: "Expired", name: "Expired" },removed it , add new column Expired
        { id: "N/A", name: "N/A" },
      ]}
    />
  );
};

export default FilterVerificationStatus;
